import React, { useEffect, useState } from 'react';

/**
 * Fine barre de progression rouge qui suit le scroll.
 * - Fixée en haut, au-dessus du Topbar (z-50)
 * - Hauteur 2.5px
 * - Cachée si scrollHeight ≈ viewport (rien à scroller)
 * - Respecte prefers-reduced-motion (transition coupée)
 */
export function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const compute = () => {
      const doc = document.documentElement;
      const body = document.body;
      const scrollTop = window.scrollY || doc.scrollTop;
      const scrollHeight = Math.max(doc.scrollHeight, body.scrollHeight) - window.innerHeight;
      if (scrollHeight <= 80) {
        setEnabled(false);
        setProgress(0);
        return;
      }
      setEnabled(true);
      const pct = Math.min(100, Math.max(0, (scrollTop / scrollHeight) * 100));
      setProgress(pct);
    };
    compute();
    window.addEventListener('scroll', compute, { passive: true });
    window.addEventListener('resize', compute);
    // Recompute when DOM mutates (route change adds content)
    const mut = new MutationObserver(() => window.requestAnimationFrame(compute));
    mut.observe(document.body, { childList: true, subtree: true });
    return () => {
      window.removeEventListener('scroll', compute);
      window.removeEventListener('resize', compute);
      mut.disconnect();
    };
  }, []);

  return (
    <div
      className="c2r-scroll-progress"
      role="progressbar"
      aria-valuenow={Math.round(progress)}
      aria-valuemin={0}
      aria-valuemax={100}
      aria-label="Progression de la lecture"
      data-testid="scroll-progress"
      data-enabled={enabled ? '1' : '0'}
    >
      <div className="c2r-scroll-progress__fill" style={{ width: `${progress}%` }} />
    </div>
  );
}
